import React from "react";
import { GridToolbar } from "@mui/x-data-grid";
import { Box, Button, Typography, useTheme } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";

const UserGridCustomToolbar = ({ onAddToGroupClick, sx={} }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      width: "100%",
      m: 1,
      cursor: "pointer",
      transition: "background-color 0.3s ease-in-out",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.8) !important",
        "& *": {
          color: "#8A8A8A",
        },
      },
      ...sx,
    }}
    onClick={onAddToGroupClick}
  >
    <GroupAddIcon color="primary" />
    <Typography variant="label" sx={{ marginLeft: 0.5 }}>
      Add to Group
    </Typography>
  </Box>
);

export default UserGridCustomToolbar;
